import { useState } from "react";
import { api } from "../api";
import { friendlyAdminError } from "../apiError";
import { useT } from "../i18n";
import { HeyLifeTile } from "../components/Brand";
import { Msg } from "../ui";

/**
 * Invited pastors and admins land here until they confirm access.
 * Two-factor enrolment is paused; this only flips church_members.active.
 */
export function StaffActivate({ onDone, onSignOut }: { onDone: () => void; onSignOut: () => void }) {
  const { t } = useT();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function activate() {
    setBusy(true);
    setErr(null);
    try {
      await api("/me/staff/activate", { method: "POST" });
      setDone(true);
      onDone();
    } catch (e) {
      setErr(friendlyAdminError(t, e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="card" style={{ width: "min(100%, 520px)" }}>
        <span className="brand">
          <HeyLifeTile size={40} />
          Hey Life
        </span>
        <h1>{t("admin.activate.title")}</h1>
        {done ? (
          <p className="success">{t("admin.activate.done")}</p>
        ) : (
          <>
            <p className="muted">{t("admin.activate.body")}</p>
            <button className="btn" disabled={busy} onClick={() => void activate()}>
              {t("admin.activate.start")}
            </button>
          </>
        )}
        <Msg msg={err ? { kind: "error", text: err } : null} />
        <button type="button" className="btn secondary" onClick={onSignOut}>
          {t("admin.login.signOut")}
        </button>
      </div>
    </div>
  );
}
